import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import findKey from 'lodash/findKey';
import uniq from 'lodash/uniq';
import { groupByBinary } from './arrayUtil';
var SCHEDULE_EXPR = /Schedule (.*)/i;

/**
 * Consolidates schedules into a more condensed format.
 * @param forms
 */
export var consolidateSchedules = function consolidateSchedules(forms) {
  forms = uniq(forms).filter(function (x) {
    return x;
  });
  var _groupByBinary = groupByBinary(forms, function (item) {
      if (typeof item !== 'string') {
        item = "".concat(item);
      }
      return item.match(SCHEDULE_EXPR);
    }),
    _groupByBinary2 = _slicedToArray(_groupByBinary, 2),
    schedules = _groupByBinary2[0],
    other = _groupByBinary2[1];
  return [].concat(_toConsumableArray(other || []), _toConsumableArray(schedules.length > 0 ? ['Schedule ' + schedules.map(extractScheduleType).join(' / ')] : []));
};

// Extracts the schedule type from a "Schedule X" string
var extractScheduleType = function extractScheduleType(schedule) {
  var result = SCHEDULE_EXPR.exec(schedule);
  return result[1];
};

/**
 * Shortens state names.
 *
 * @param states
 */
export var shortenStates = function shortenStates(states) {
  states = states || [];
  return states.map(function (state) {
    return [getStateAbbreviation(state), state];
  });
};
var getStateAbbreviation = function getStateAbbreviation(state) {
  return findKey(STATES, function (name) {
    return name === state;
  });
};

// All states
var STATES = {
  AL: 'Alabama',
  AK: 'Alaska',
  AS: 'American Samoa',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District Of Columbia',
  FM: 'Federated States Of Micronesia',
  FL: 'Florida',
  GA: 'Georgia',
  GU: 'Guam',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MH: 'Marshall Islands',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  MP: 'Northern Mariana Islands',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PW: 'Palau',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VI: 'Virgin Islands',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming'
};
//# sourceMappingURL=jobUtil.js.map
